// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/copilot_cel/v1/private/copilot_cel.proto" (package "c1.api.copilot_cel.v1.private", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { HelperService } from "./copilot_cel";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetHelperServiceResponse } from "./copilot_cel";
import type { GetHelperServiceRequest } from "./copilot_cel";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.copilot_cel.v1.private.HelperService
 */
export interface IHelperServiceClient {
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: GetHelperServiceRequest, options?: RpcOptions): UnaryCall<GetHelperServiceRequest, GetHelperServiceResponse>;
}
/**
 * @generated from protobuf service c1.api.copilot_cel.v1.private.HelperService
 */
export class HelperServiceClient implements IHelperServiceClient, ServiceInfo {
    typeName = HelperService.typeName;
    methods = HelperService.methods;
    options = HelperService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: GetHelperServiceRequest, options?: RpcOptions): UnaryCall<GetHelperServiceRequest, GetHelperServiceResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetHelperServiceRequest, GetHelperServiceResponse>("unary", this._transport, method, opt, input);
    }
}
